import React, {Component} from "react"
import {Container, Header, Loader, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, parseMultilineString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getStepProps, isAnsel, isDistributionChannelIndividual, truncTwoDec, uiFlowBenAdmin} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import moment from "moment";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {prepareDiagnosisService} from "../services/services";
import {PrepareDiagnosisRequest} from "../services/types";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    return {
        ...ownProps,
        lang: user.lang,
        user, initialData, benAdmin,
    }
};

class Diagnoses extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            costEe: null,
            costTier: null,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
        this.prepareDiagnoses().then();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    prepareDiagnoses = async () => {
        const {initialData, user} = this.props;
        if (isDistributionChannelIndividual(initialData.distributionChannel)) {
            return;
        }
        const {maritalStatus, dependents} = user;
        this.setState({loadingPrepare: true});
        try {
            const { ratedClass } = initialData;
            const { contractTerms } = ratedClass || {};

            const chronicBenefit = contractTerms?.chronicBrokerRequested ? contractTerms.chronicCoverageLimit : 0;
            const mentalBenefit = contractTerms?.mentalBrokerRequested ? contractTerms.mentalCoverageLimit : 0;
            const maternityBenefit = contractTerms?.maternityBrokerRequested ? contractTerms.maternityCoverageLimit : 0;

            let moderateBenefit = 0;
            let severeBenefit = 0;
            let catastrophicBenefit = 0;
            const isSelect = initialData.contractInfo.planOffering === "Brella Select";
            if(!isSelect){
                moderateBenefit = initialData.increments.moderate[0];
                severeBenefit = initialData.increments.severe[0];
                catastrophicBenefit = initialData.increments.catastrophic[0];
            }

            const isBenAdmin = initialData.uiFlow === uiFlowBenAdmin;
            let ageAtPolicyEffectiveDate = initialData.ageAtPolicyEffectiveDate;
            if (isBenAdmin) {
                ageAtPolicyEffectiveDate = moment(initialData.policy.polEDate, 'YYYY-MM-DD').diff(moment(user.birthdate, 'MM/DD/YYYY'), 'years');
            }
            const payload = new PrepareDiagnosisRequest ({
                token: initialData.token,
                maritalStatusId: maritalStatus,
                dependentsId: dependents,
                moderateBenefit,
                severeBenefit,
                catastrophicBenefit,
                mentalBenefit,
                chronicBenefit,
				maternityBenefit,
                ageAtPolicyEffectiveDate,
                payrollFrequencySelected: initialData.payrollFrequencySelected,
                planOffering: initialData.contractInfo.planOffering,
                employerContribution: initialData.employerContribution,
                quoteInfo: initialData.quoteInfo,
                presets: initialData.presets,
                ratedClassRates: initialData.ratedClass.ratedClassRates,
            });
            const result = await prepareDiagnosisService(payload);
            if(!!result && !!result.data){
                const data = result.data;
                this.setState({
                    loadingPrepare: false,
                    costEe: data.costEE,
                    costTier: data.costTier,
                });
            } else {
                this.setState({
                    loadingPrepare: false,
                });
            }
        } catch(e) {
            console.error(e);
            this.setState({loadingPrepare: false});
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    render() {
        const {initialData, user} = this.props;
        const {stepProps, costEe, costTier} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.diagnoses;
        const isIndividual = isDistributionChannelIndividual(initialData.distributionChannel);

        const {maritalStatus, dependents} = user;
        const MARRIED_ID = 1;
        const KIDS_UNDER_18 = 1;
        let startsAtEndindPhrase;
        let showFamilyPrice = false;
        if(maritalStatus === MARRIED_ID){
            showFamilyPrice = true
            if(dependents === KIDS_UNDER_18){
                startsAtEndindPhrase = strings.forFamilyCoverage;
            } else {
                startsAtEndindPhrase = strings.forSpouseCoverage;
            }
        } else {
            if(dependents === KIDS_UNDER_18){
                showFamilyPrice = true
                startsAtEndindPhrase = strings.forChildrenCoverage;
            } else {
                startsAtEndindPhrase = strings.coverYourself;
            }
        }

        const isMonthly = initialData.payrollFrequencySelected === initialData.payrollFrequencyMonthly;
        let startsAtFollowingPhrase = strings.perPaycheck;
        if(isMonthly){
            startsAtFollowingPhrase = strings.perMonth;
        } else if ((initialData.payrollFrequencySelected || "").toLowerCase().includes("bi-weekly")){
            startsAtFollowingPhrase = strings.perPayPeriod;
        }

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>

                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <Header as='h2'>{strings.title}</Header>
                                        <p className={"neutral700Text"}>{parseMultilineString(strings.subTitle)}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                <CustomGrid.Row>
                                    <CustomGrid.Column>
                                        <p className="primaryHeaderColor"><b>{strings.payouts}</b></p>

                                        <CustomGrid columns={3}>
                                            <CustomGrid.Column width={12} style={{paddingBottom: 0, paddingLeft: '.5em'}}>
                                                <S3Image {...IMAGE[strings.imgName]}/>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column>
                                                <div>
                                                    <span className="secondaryHeaderColor"><b>{strings.moderate}</b></span>
                                                    <span className="smaller neutral700Text"> $$</span>
                                                </div>
                                                <div className={"small neutral700Text"}>{strings.moderateConditions}</div>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column>
                                                <div style={{paddingLeft: "1em"}}>
                                                <div>
                                                    <span className="secondaryHeaderColor"><b>{strings.severe}</b></span>
                                                    <span className="smaller neutral700Text"> $$$</span>
                                                </div>
                                                <div className={"small neutral700Text"}>{strings.severeConditions}</div>
                                                </div>
                                            </CustomGrid.Column>
                                            <CustomGrid.Column textAlign={"right"}>
                                                <div style={{display: "inline-block", textAlign: "left"}}>
                                                <div>
                                                    <span className="secondaryHeaderColor"><b>{strings.catastrophic}</b></span>
                                                    <span className="smaller neutral700Text"> $$$$</span>
                                                </div>
                                                <div className={"small neutral700Text"}>{strings.catastrophicConditions}</div>
                                                </div>
                                            </CustomGrid.Column>
                                        </CustomGrid>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                {!isIndividual &&
                                <CustomGrid.Row>
                                    <CustomGrid.Column className={"neutral700Text"}>
                                        {strings.choose}
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                }
                                {!isIndividual &&
                                <CustomGrid.Row>
                                    <CustomGrid.Column textAlign={'center'}>
                                        <Segment padded>
                                            <p>
                                                <S3Image {...IMAGE.MONETIZATION_ON}/>
                                                <b>{strings.planStartsAt}{!!costEe ? truncTwoDec(costEe) : costEe}</b>{' '}<span className={"neutral700Text"} >{startsAtFollowingPhrase}{strings.coverYourself}</span>
                                            </p>
                                        </Segment>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                }
                                {!isIndividual && !!showFamilyPrice &&
                                <CustomGrid.Row>
                                    <CustomGrid.Column className={"small neutral700Text"} textAlign={"center"}>
                                        <p>{strings.or}</p>
                                        <p><b>${!!costTier ? truncTwoDec(costTier) : costTier}</b>{' '}{startsAtEndindPhrase}</p>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                                }
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(Diagnoses));
